<template>
  <nav class="navbar navbar-light">
    <div class="container">
      <div class="back"  @click="$router.go(-1)"><i class="iconfont">&#xe65b;</i></div>

    </div>
  </nav>
</template>

<script>
export default {
  name: "NewsHeader",
  
};
</script>
